export default __webpack_public_path__ + "media/images/pumpkin-holding-b73c40a1c97193094666f18625585b29.jpg";